

var _constants = require('./constants');

var mapCartParams = function mapCartParams(buttonParams, jsonParams) {
    if (jsonParams[_constants.XCLICK_VARS.INVOICE]) {
        buttonParams[_constants.SHOPPINGCART_VARS.INVOICE_NUMBER] = jsonParams[_constants.XCLICK_VARS.INVOICE];
    }
    if (jsonParams['no_note'] === '0') {
        buttonParams['prompt_note'] = true;
    } else {
        buttonParams['prompt_note'] = false;
    }
    if (jsonParams['address_override'] === '0') {
        buttonParams['address_override'] = false;
    } else if (jsonParams['address_override'] === '1') {
        buttonParams['address_override'] = true;
    }
    return buttonParams;
};

var mapUrlParams = function mapUrlParams(buttonParams, jsonParams, urlParams) {
    buttonParams.urls = {};
    for (var key in urlParams) {
        if (urlParams.hasOwnProperty(key) && jsonParams[key]) {
            buttonParams.urls[urlParams[key]] = jsonParams[key];
        }
    }
    return buttonParams;
};

var isAddToCart = function isAddToCart(jsonParams) {
    var addToCart = false;
    if (jsonParams[_constants.XCLICK_VARS.ADD] === '1') {
        addToCart = true;
    }
    return addToCart;
};

var isAddressOverride = function isAddressOverride(jsonParams) {
    return jsonParams[_constants.XCLICK_VARS.ADDRESS_OVERRIDE] === '1';
};

var mapShippingAddress = function mapShippingAddress(buttonParams, jsonParams) {
    var addressParams = {
        address1: _constants.ADDRESS_VARS.LINE1,
        address2: _constants.ADDRESS_VARS.LINE2,
        city: _constants.ADDRESS_VARS.CITY,
        country: _constants.ADDRESS_VARS.COUNTRY_CODE,
        zip: _constants.ADDRESS_VARS.POSTAL_CODE,
        state: _constants.ADDRESS_VARS.STATE
    };
    for (var key in addressParams) {
        if (addressParams.hasOwnProperty(key) && jsonParams[key]) {
            if (!buttonParams.shipping_address) {
                buttonParams.shipping_address = {};
            }
            buttonParams.shipping_address[addressParams[key]] = jsonParams[key];
        }
    }
    if (buttonParams.shipping_address) {
        if (!buttonParams.payer_info) {
            buttonParams.payer_info = {};
        }
        buttonParams.payer_info.billing_address = buttonParams.shipping_address;
    }
    return buttonParams;
};

var mapPayeePayerParams = function mapPayeePayerParams(buttonParams, jsonParams) {
    buttonParams = mapPayeeParams(buttonParams, jsonParams);
    buttonParams = mapPayerParams(buttonParams, jsonParams);
    return buttonParams;
};

var mapPayeeParams = function mapPayeeParams(buttonParams, jsonParams) {
    buttonParams.visitor_id = jsonParams[_constants.XCLICK_VARS.VISITOR_ID];
    buttonParams.payee = {};
    buttonParams.payee.email = jsonParams[_constants.XCLICK_VARS.MERCHANT_EMAIL];
    buttonParams.payee.business_name = jsonParams[_constants.XCLICK_VARS.BUSINESS_NAME];
    if (!buttonParams.payee.business_name) {
        buttonParams.payee.business_name = buttonParams.payee.email;
    }
    return buttonParams;
};

var mapPayerParams = function mapPayerParams(buttonParams, jsonParams) {
    var payerParams = {
        email: _constants.PAYER_VARS.EMAIL,
        first_name: _constants.PAYER_VARS.FIRST_NAME,
        last_name: _constants.PAYER_VARS.LAST_NAME
    };
    for (var key in payerParams) {
        if (payerParams.hasOwnProperty(key) && jsonParams[key]) {
            if (!buttonParams.payer_info) {
                buttonParams.payer_info = {};
            }
            buttonParams.payer_info[payerParams[key]] = jsonParams[key];
        }
    }
    buttonParams = mapPhone(buttonParams, jsonParams);
    return buttonParams;
};

var mapPhone = function mapPhone(buttonParams, jsonParams) {
    var phoneParams = [_constants.PHONE_PARAMS.NIGHT_PHONE_A, _constants.PHONE_PARAMS.NIGHT_PHONE_B, _constants.PHONE_PARAMS.NIGHT_PHONE_C];
    var phone = void 0;
    for (var i = 0; i < phoneParams.length; i += 1) {
        if (jsonParams[phoneParams[i]]) {
            phone = phone || '';
            phone += jsonParams[phoneParams[i]];
        }
    }
    if (phone) {
        buttonParams.payer_info = buttonParams.payer_info || {};
        buttonParams.payer_info.phone = phone;
    }
    return buttonParams;
};

module.exports = {
    mapCartParams: mapCartParams,
    mapUrlParams: mapUrlParams,
    isAddToCart: isAddToCart,
    isAddressOverride: isAddressOverride,
    mapShippingAddress: mapShippingAddress,
    mapPayeePayerParams: mapPayeePayerParams,
    mapPayeeParams: mapPayeeParams,
    mapPayerParams: mapPayerParams,
    mapPhone: mapPhone
};
_constants.XCLICK_VARS;

_constants.ADDRESS_VARS;

_constants.PAYER_VARS;

_constants.SHOPPINGCART_VARS;

_constants.PHONE_PARAMS;


//////////////////
// WEBPACK FOOTER
// ./js/lib/xclickUtil.js
// module id = ./js/lib/xclickUtil.js
// module chunks = 0